
import { Component, ViewEncapsulation ,signal} from "@angular/core";
interface NavItem {
    name: string;
    link?: string; 
    icon?: string; 
    children?: NavItem[]
}
@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    encapsulation:ViewEncapsulation.None,
    standalone:false
})
export class SideNavComponent {
  public activeButton={
    Products: false,
    Solutions: false,
    Integrations: false,
    Resources: false
  }
  // Functions to open and close the mat-menu for each button and based on active button name we can add special class to mat-button to decorate it or change its color

  // private currentActiveButton:string|null = null;
  // handleClick(buttonName: string) {
  //   if(this.currentActiveButton === buttonName){
      
  //     this.activeButton[buttonName] = !this.activeButton[buttonName];
  //     this.currentActiveButton = this.activeButton[buttonName] ? buttonName : null;
  //   }
  //   else{
  //     for(const key in this.activeButton){
  //       if(buttonName!=key)
  //       this.activeButton[key] = false;
  //     }
  //     this.activeButton[buttonName] = true;
  //     this.currentActiveButton = buttonName
  //   }

  // }

  // handleMenuClosed(buttonName: string) {
  //   if(this.currentActiveButton === buttonName && this.activeButton[buttonName]){

  //     this.activeButton[buttonName] = false;
  //     this.currentActiveButton = null;
  //   }
  // }

}
